export default __webpack_public_path__ + "static/media/risk-logo.193e2903.png";